module.exports = __webpack_public_path__ + "img/box-arrow-down-left.3acad920.svg";